<template>
	<ppe-form 
		ref="form"
		entityName="D4"
		title="D4. BORDEREAU D’ENGAGEMENT SST de l’Opération -" 
		title-field="{company.name}, {operation.code}, {operation.operationname}"
 	    sub-title=""

		:schema="schema" 
		:endpoint="endpoint"
		:redirect="'/ppe_ee/operation_home_ee/:operationid'" 
		v-on:dataLoaded="onDataLoaded"
		>

	</ppe-form>
</template>
<script>
 
import { OPERATION } from 'ppe-business';
import Utils    from '../ppe/utils'

export default {
	
	data() {
		console.log("this.$route.params.operationid", this.$route.params.operationid)
		console.log("this", this)
		return {
			operation : {},
			endpoint : "/ee/d4?id=" + this.$route.params.id+'&operationid='+this.$route.query.operationid+"&companyid="+this.$route.query.companyid,
			
			schema : [
				{ card:"Chargement ...",
						body:[	{component:'div', children:'en cours'} ]
				}
			]
		}
	},
	methods: {
		onDataLoaded(data) {
			console.log("onDataLoaded", data.operation)
			this.operation = data.operation
			console.log("onDataLoaded.this.$refs.form", this.$refs.form)
			//this.$refs.form.parseSchema() // = this.schema

			this.schema = [
				{ card:"Bordereau d'engagement Sécurité et Santé au Travail <br>&nbsp;<span style='font-size:17px'>valant \"visite d'inspection préalable\"</span>",
					body:[
						{name:"tasksDescription",    	   label:"Description des Tâches ou Travaux à effectuer",  type: "textarea",  placeholder:'une ligne pour chaque tâche prévue', validation:'required',    size: 'large'},

						{name:"signcompanyOwner",     label:"Le soussigné :", placeholder:"Votre nom",   type: "text", validation:'required', size: 'medium'},
						{name:"signcompanyOwnerPhone",  label:"portable :", placeholder:"06 00 00 00 00",  type: "text", validation:'required', size: 'medium'},

						{name:"signcompanyName",    	label:"Représentant de l’Entreprise Extérieure",  type: "text", placeholder:'', validation:'required',    size: 'medium'},
						{name:"signcompanySiret",    	label:"SIRET",  type: "text", placeholder:'', validation:'required',    size: 'medium'},

						{name:"signcompanyAddress",   label:"Adresse siège social",  type: "textarea",  placeholder:'une ligne pour chaque tâche prévue', validation:'required',    size: 'large'},

						{name:"signPresenceOf",    	  label:"En présence de :",  type: "text", placeholder:'Représentant de l’Entreprise Utlisatrice / Extérieure attributaire', validation:'',    size: 'medium'},
						{name:"signPresenceOfPhone",  label:"portable :", placeholder:"06 00 00 00 00",  type: "text", validation:'', size: 'small'},
						{name:"signPresenceOfEmail",  label:"email :", placeholder:"pro@email.com",  type: "text", validation:'', size: 'small'},
						{name:"signPresenceOfType",   label:"Cocher A ou B :",  type: "radio", size:"large",
						options:{
							a: "A - Représentant de l’Entreprise Utlisatrice",
							b: "B - Représentant de l’entreprise extérieure de rang 1 ; si la VIP concerne une sous-traitante, représetnant de l’entreprise de rang 2."
						}},

						{component:'b', children: [{component:'label-editable', resourcekey:'template_d4_reco', size:"large", text:"Reconnaît par la présente ..." }], },
						{component:'label-editable', resourcekey:'template_d4_items', size:"large", text:"<li>des risques propres à ...", 
							params: { "{{operation.company.name}}":this.operation.operationname, "{{operation.sitename}}":this.operation.sitename } 
						},
						
						/*{component:"b", children:"Reconnaît par la présente avoir pris connaissance :", size:"large"},
						
						{component:"li", children:"des risques propres à l’Entreprise Utilisatrice identifiés dans son Plan de Prévention matriciel, transcrits  dans son Livret d’Accueil Prévention \"Identificatioin des dangers et des risques du site\".", size:"large"},
						{component:"li", children:"des risques générés par son intervention sur le site et ceux générés par les autres Entreprises Extérieures travaillant sur le site, lesquels risques sont reportés dans le «Plan de Prévention Evolutif » à partir des informations de leur «Livret d’Accueil Prévention », au fur et à mesure  de leur arrivée sur le site / pôle de l’Opération.", size:"large"},
						*/
						//{component:"p", size:"large"},

						{component:'label-editable', resourcekey:'template_d4_engage', size:"large", text:"S'engage ...", params: { "{{operation.code}}": this.operation.code } },

						/*{component:"li", children:"à informer ses personnels des consignes de Sécurité et Santé au Travail prises en commun, dont, celles liées à la spécificité des risques biologiques", size:"large"},
						{component:"li", children:"à faire respecter le Plan de Prévention Évolutif de l’opération", size:"large"},
						{component:"li", children:"à vérifier que chacun de ses personnels est en possession de sa Carte d’Identité Professionnelle", size:"large"},
						{component:"li", children:"à s’assurer de la présence sur site d’un Sauveteur Secouriste au Travail", size:"large"},
						{component:"li", children:"à obliger ses personnels au port des EPI conformes à son activité", size:"large"},*/

						//{component:"p", size:"large"},

						{name:"signPlace",  label:"Fait à :",   type: "text", validation:'required', size: 'small'},
						{name:"signDate",  	label:"Le",    		type: "datepicker", validation:'required', size: 'small', placeholder:'JJ/MM/AAAA', size:'small', language:"fr", format:"dd/MM/yyyy", typeable:true},
						{component:"div", children:"", size:"medium"}, // Line break
						

					],
				},
				
				Utils.getGetManagerCard(),
				Utils.getAdminCard(),
				];
		},
		
		getOperation() {
			return this.operation || { }
		}
	}

};
</script>
<style>
.display-inline {
	display:   flex;
	flex-wrap: wrap;
}

.formulate-input-element-checkboxtable .formulate-input-label {
	/*white-space:nowrap;*/
	min-width: 40%;
}
</style>
